import { Box, styled } from '@mui/material';

const CpdCardBoxStyle = styled(Box)(
  ({ theme }) => `
  position: relative;
  min-height: 200px;
  width: 100%;
  padding: 24px;
  background: #ffffff;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  display: flex;
  gap: 48px;

  ${theme.breakpoints.down('md')} {
    flex-direction: column;
    gap: 24px;
  }

  .image-card {
    border-radius: 10px;
    border: 1px solid #0000001f;
    width: auto;
    height: 160px;
    object-fit: contain;
    ${theme.breakpoints.down('md')} {
      width: 100%;
      height: auto;
    }
  }
`,
);

export default CpdCardBoxStyle;
